<mat-card>
  <div class="container table-container" style="background-color: #f5f7fa">
    <!-- <div class="sticky-0" style="float: right;">
    <h3 class="fw-400" style="text-align: center;">{{ name }}</h3>
    <h6 class="badge badge-success badge-users">
      <span class="ft-users"></span> {{ totalPlayers }}
    </h6>
  </div> -->
  <div class="sticky-0">
    <div>
      <h5 class="fw-400">{{ name }}</h5>
      <h6 class="badge badge-success badge-users" style="float: right">
        <span class="ft-users"></span> {{ totalPlayers }}
      </h6>
    </div>
    @if (showDownloadButton) {
      <button
        type="button"
        class="btn btn-raised btn-success btn-sm btn-action mlr-2"
        style="margin-left: 5px"
        (click)="downloadReport()"
        >
        <span class="fa fa-download"></span> Download
      </button>
    }
  </div>
  <!-- <div class="search-holder">
  <form [formGroup]="searchForm" class="example-form">
    <mat-form-field class="example-full-width" style="float: right;" appearance="outline">
      <mat-label>Search</mat-label>
      <input type="search" matInput formControlName="searchCtrl" #message maxlength="25" placeholder="Search" />
    </mat-form-field>
  </form>
</div> -->

<table class="table">
  <thead>
    <tr>
      <th>#</th>
      <ng-container>
        @for (column of columns; track column) {
          <th [width]="column['width']">
            {{ column['name'] }}
          </th>
        }
      </ng-container>
    </tr>
  </thead>
  <tbody>
    @if (data && data.length <= 0) {
      <tr>
        <td></td>
        <td>NO DATA FOUND</td>
      </tr>
    }
    @for (row of data; track row; let i = $index) {
      <tr style="cursor: pointer">
        <!-- {{row| json}} -->
        @if (showIndexColumn) {
          <td>
            <strong>{{ i + 1 }}</strong>
          </td>
        }
        @for (column of columns; track column) {
          @switch (column['type']) {
            @case ('date') {
              <td>
                {{ row[column['key']] | date: 'd MMM, y' }}
              </td>
            }
            @case ('number') {
              <td>
                {{ row[column['key']] | number }}
              </td>
            }
            @default {
              <td>
                {{ row[column['key']] }}
              </td>
            }
          }
        }
      </tr>
    }
  </tbody>
</table>
</div>
</mat-card>
